import React from 'react'
import Search from '../components/Search'
import Header from '../components/Header'

const Roadmap = () => {
  return (
    <><Header /><Search /></>
  )
}

export default Roadmap